import React from "react"
import { secondary } from "../../assets/strings/variables"
import { NavLink } from "react-router-dom"
import AsistenAi from '../../assets/images/Home/OurSolutions/E_commerce-logo_client.png'
import HealtyCare from '../../assets/images/Home/OurSolutions/Health_Care.png'
import { ourSolutionsData } from "../../pages/Homepage/homepageData"

// const ourSolutionsData = [
//     {
//         image: AsistenAi,
//         link: 'E-commerce',
//         title: "Asisten AI",
//         desc: 'Kami siap membantu bisnis Anda menghadapi tantangan era digital. Melalui layanan konsultasi, kami merancang strategi yang tepat, mengidentifikasi peluang terbaik, dan menyusun langkah-langkah konkret yang sejalan dengan tujuan bisnis Anda, sekaligus memastikan kepatuhan pada standar industri.',
//     },
//     {
//         image: HealtyCare,
//         link: 'E-commerce',
//         title: "Layanan Kesehatan",
//         desc: 'Kami siap membantu bisnis Anda menghadapi tantangan era digital. Melalui layanan konsultasi, kami merancang strategi yang tepat, mengidentifikasi peluang terbaik, dan menyusun langkah-langkah konkret yang sejalan dengan tujuan bisnis Anda, sekaligus memastikan kepatuhan pada standar industri.',
//     },
// ]

function OurPortfolioNew() {
    return (
        <section
            id="our-solution"
        >
            <div className="text-[32px] text-center font-semibold ">Portfolio Kami</div>
            {/* container */}
            <div className="py-6 sm:py-10 grid">
                {/* grid content */}
                <div className="grid grid-cols-1 gap-3 sm:gap-5 md:grid-cols-3 m-auto">
                    {ourSolutionsData.map(({ title, desc, image, link }, idx) => (
                        <NavLink
                            to={"/ai-solution/" + link}
                            className="rounded-xl max-w-[384px] xsm:p-3 md:p-6 h-auto bg-[#F7F7F7]"
                            key={`solution-${idx}`}
                        >
                            <div className="flex flex-col h-full w-full mb-6 inline-block">
                                <img src={image} alt={title} className="justify-self-center justify-items-center" />
                                <div className="pt-5">
                                    <div className="font-semibold mb-2 xsm:text-base md:text-xl">{title}</div>
                                    <div className={`text-[${secondary}] xsm:text-sm md:text-base`}>{desc}</div>
                                </div>
                            </div>
                        </NavLink>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default OurPortfolioNew
